import enText from "./translation/en.json";

const TEXT_ROOT = {
  editBooking: enText,
  ByTheHour: {
    TravelArea: {
      Title: "Travel Area",
      WithinCity: "Within City",
      NeighboringPerfecture: "Neighboring Prefecture",
      Undecided: "Undecided",
    },
  },
  SelectCountry: {
    Placeholder: "Select country",
  },
  Pick: {
    Up: {
      Time: "Pick-up time",
    },
  },
  myPage: {
    booking: {
      bookingItem: {
        travelArea: {
          withinCity: "Within City",
          neighboringPerfecture: "Neighboring Prefecture",
          undecided: "Undecided",
        },
      },
    },
  },
  my_page: {
    bookings_page: {
      booking_item: {
        both: "Both",
        airport_meet_assist: "Airport Meet & Assist",
      },
    },
  },
  bookingDetail: {
    bookingItem: {
      terminal: {
        "terminal-1": "Terminal 1",
        "terminal-2": "Terminal 2",
        "terminal-3": "Terminal 3",
        "terminal-1-domestic": "Terminal 1 (Domestic)",
        "terminal-2-domestic": "Terminal 2 (Domestic)",
        "terminal-2-international": "Terminal 2 (International)",
        "terminal-3-international": "Terminal 3 (International)",
      },
    },
  },
};

const getByPath = (obj, path) =>
  path.split(".").reduce((acc, segment) => (acc && acc[segment] !== undefined ? acc[segment] : undefined), obj);

const interpolate = (text, vars = {}) =>
  String(text).replace(/{{\s*(\w+)\s*}}/g, (_, key) =>
    vars[key] !== undefined && vars[key] !== null ? String(vars[key]) : ""
  );

export const translateBookingEdit = (key, options = {}) => {
  const value = getByPath(TEXT_ROOT, key);

  if (value !== undefined) {
    if (options?.returnObjects) {
      return value;
    }
    return typeof value === "string" ? interpolate(value, options) : value;
  }

  return key;
};

export const useBookingEditText = () => ({
  t: translateBookingEdit,
  language: "en",
});
